import * as React from "react";
import {Grid, Card, Button, Icon, Form, Table} from "tabler-react";
import SiteWrapper from "../../../SiteWrapper.react";
import Crud_Catalogos from "../../../herramientas/Crud_Catalogos";
import RemolquesForm from "../../../Catalogos/Remolques/RemolquesForm";
import ModalLay from "../../../components/ModalLay/ModalLay";
import ModalCargaMasiva from "../../../components/CargaMasivaGenerico/ModalCargaMasiva";
import TableSkeleton from "../../../components/TableSkeleton/TableSkeleton";
import { remolquesConfig } from "../../../components/CargaMasivaGenerico/configuraciones";
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import "./RemolquesPage.css";

function getSessionData(key) {
  try { return JSON.parse(sessionStorage.getItem(key)); } catch (e) { return null; }
}

function getfuntion (metodo = "get", obj = [], id = "", catalogo = "", stateVar = "", hiddenModl = "") {
  Crud_Catalogos(catalogo, "perfiles", metodo, id, obj, "", stateVar, hiddenModl, []).then((returnVal) => {
    switch (metodo) {
      case "get": 
      if (stateVar === "funcionalidades") {
        if (Array.isArray(returnVal)) {
          for( let item of returnVal){
            if(item.nombre == "Remolques"){ return true; }
          }
        }
        window.history.back();
        window.location.href = "403";
      }  break;
      default:
        break;
    }
  }).catch(err => { console.log("Error desconocido ...."+ err); })
}

class RemolquesPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hiddenModals: false,
      remolques: [],
      remolquesDeshabilitados: [],
      cargandoRemolques: true,
      paginaActual: 1,
      registrosPorPagina: 10,
      remolqueEditar: null,
      accionModal: "nuevo",
      busqueda: "",
      idTransportista: null,
      mostrarDeshabilitados: false,
      procesando: false,
      modalConfirmar: { visible: false, remolque: null, accion: null },
      showCargaMasiva: false
    };
  }

  componentDidMount() {
    const currentUser = getSessionData("currentUser");
    if (!currentUser || !currentUser[0]?.perfil?.id) return;
    getfuntion("get", "", "", "funcionalidades/Administracion_Transportista/"+currentUser[0].perfil.id, "funcionalidades");
    this.obtenerIdTransportista();
  }

  obtenerIdTransportista = () => {
    const usuario = getSessionData("usuario");
    const currentUser = getSessionData("currentUser");
    if (usuario && currentUser) {
      const plataformasIds = [...new Set(currentUser.map(c => c.plataforma?.id).filter(Boolean))];
      const promesas = plataformasIds.map(idPlat =>
        Crud_Catalogos("usuarios_transportistas/usuario/" + usuario.id + "/plataforma/" + idPlat, "", "get", "", [], "", "", "", []).catch(() => [])
      );
      Promise.all(promesas).then((resultados) => {
        const todos = resultados.flat();
        const idsUnicos = [...new Set(todos.filter(t => t.idTransportista !== null).map(t => t.idTransportista))];
        if (idsUnicos.length > 0) {
          this.setState({ idTransportista: idsUnicos[0], idsTransportistas: idsUnicos }, () => {
            this.cargarRemolques();
          });
        } else {
          this.setState({ cargandoRemolques: false });
        }
      }).catch(err => {
        console.log("Error al cargar transportistas:", err);
        this.setState({ cargandoRemolques: false });
      });
    } else {
      this.setState({ cargandoRemolques: false });
    }
  };

  cargarRemolques = () => {
    this.setState({ cargandoRemolques: true });
    
    const { idsTransportistas } = this.state;
    
    if (!idsTransportistas || idsTransportistas.length === 0) {
      this.setState({ cargandoRemolques: false });
      return;
    }
    
    // Obtener relaciones desde remolques_transportistas (todos los transportistas del perfil)
    Promise.all(idsTransportistas.map(id =>
      Crud_Catalogos("remolques_transportistas/id_transportista/" + id, "", "get", "", [], "", "", "", []).catch(() => [])
    )).then((resultados) => {
      const todasRelaciones = resultados.flat();
      // Mapear idRemolque -> estatus (deduplicar, si aparece en varios transportistas)
      const remolqueEstatus = new Map();
      todasRelaciones.forEach(r => {
        // Si ya existe y alguno es activo, mantener activo
        const prev = remolqueEstatus.get(r.idRemolque);
        if (!prev || r.estatus) {
          remolqueEstatus.set(r.idRemolque, r.estatus !== false);
        }
      });
      
      const idsRemolques = [...remolqueEstatus.keys()];
      
      Crud_Catalogos("remolques", "", "get", "", [], "", "", "", [])
        .then((todosRemolques) => {
          const remolquesFiltrados = todosRemolques.filter(rem => idsRemolques.includes(rem.idRemolque));

          // Cargar vinculaciones activas de GPS fijo para estos remolques
          const cargarConGps = (listaRemolques) => {
            if (idsRemolques.length === 0) {
              return Promise.resolve(listaRemolques);
            }
            return Crud_Catalogos(
              "remolquesGpsFijos/remolques/activos?ids=" + idsRemolques.join(","),
              "", "get", "", [], "", "", "", []
            ).then((vinculaciones) => {
              const gpsPorRemolque = new Map();
              const listaVinc = Array.isArray(vinculaciones)
                ? vinculaciones
                : (vinculaciones && vinculaciones.content ? vinculaciones.content : []);
              listaVinc.forEach((v) => {
                if (v.gps && v.remolque) {
                  gpsPorRemolque.set(v.remolque.idRemolque, v.gps.nombre);
                }
              });
              return listaRemolques.map((rem) => ({
                ...rem,
                gpsFijoNombre: gpsPorRemolque.get(rem.idRemolque) || null,
              }));
            }).catch(() => listaRemolques);
          };

          cargarConGps(remolquesFiltrados).then((remolquesConGps) => {
            const activos = remolquesConGps.filter(rem => remolqueEstatus.get(rem.idRemolque));
            const deshabilitados = remolquesConGps.filter(rem => !remolqueEstatus.get(rem.idRemolque));
            activos.sort((a, b) => b.idRemolque - a.idRemolque);
            deshabilitados.sort((a, b) => b.idRemolque - a.idRemolque);
            this.setState({ remolques: activos, remolquesDeshabilitados: deshabilitados, cargandoRemolques: false });
          });
        });
    }).catch(err => {
      console.log("Error al cargar remolques:", err);
      this.setState({ cargandoRemolques: false });
    });
  };

  cambiarPagina = (numeroPagina) => {
    this.setState({ paginaActual: numeroPagina });
  };

  hiddenmodal = () => {
    const estabAbierto = this.state.hiddenModals;
    this.setState({ 
      hiddenModals: !this.state.hiddenModals,
      remolqueEditar: null,
      accionModal: "nuevo",
      paginaActual: 1
    });
    if (estabAbierto) {
      this.cargarRemolques();
    }
  };

  abrirModalEditar = (remolque) => {
    this.setState({
      remolqueEditar: remolque,
      accionModal: "editar"
    }, () => {
      this.setState({ hiddenModals: true });
    });
  };

  abrirModalNuevo = () => {
    this.setState({
      remolqueEditar: null,
      accionModal: "nuevo",
      hiddenModals: true
    });
  };

  filtrarRemolques = () => {
    const { remolques, remolquesDeshabilitados, busqueda, mostrarDeshabilitados } = this.state;
    
    const lista = mostrarDeshabilitados
      ? remolquesDeshabilitados.map(r => ({...r, _activo: false}))
      : remolques.map(r => ({...r, _activo: true}));

    if (!busqueda.trim()) return lista;

    const termino = busqueda.toLowerCase();
    return lista.filter(rem => {
      const placa = (rem.placa || '').toLowerCase();
      const economico = (rem.economico || '').toLowerCase();
      const tipo = (rem.remolquesTipos?.nombre || '').toLowerCase();
      return placa.includes(termino) || economico.includes(termino) || tipo.includes(termino);
    });
  };

  handleBusquedaChange = (e) => {
    this.setState({ busqueda: e.target.value, paginaActual: 1 });
  };

  abrirModalConfirmar = (remolque, accion) => {
    this.setState({ modalConfirmar: { visible: true, remolque, accion } });
  };

  exportarExcel = () => {
    const { remolques, remolquesDeshabilitados, mostrarDeshabilitados } = this.state;
    const lista = mostrarDeshabilitados ? remolquesDeshabilitados : remolques;
    const data = lista.map(rem => ({
      "Placa": rem.placa || '',
      "Económico": rem.economico || '',
      "Tipo de Remolque": rem.remolquesTipos?.nombre || '',
      "Estado": mostrarDeshabilitados ? 'Deshabilitado' : 'Activo'
    }));
    if (data.length === 0) return;
    const ws = XLSX.utils.json_to_sheet(data);
    ws['!cols'] = Object.keys(data[0]).map(key => ({ wch: Math.max(key.length, 12) * 1.25 }));
    const wb = { Sheets: { 'Remolques': ws }, SheetNames: ['Remolques'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    const usuario = getSessionData("usuario");
    const nombreUsuario = usuario ? (usuario.nombre || usuario.username || 'usuario') : 'usuario';
    FileSaver.saveAs(blob, `Remolques-${nombreUsuario}.xlsx`);
  };

  cerrarModalConfirmar = () => {
    this.setState({ modalConfirmar: { visible: false, remolque: null, accion: null } });
  };

  ejecutarAccionConfirmada = () => {
    const { remolque, accion } = this.state.modalConfirmar;
    const { idsTransportistas } = this.state;

    if (!idsTransportistas || idsTransportistas.length === 0) {
      console.error("No se encontraron transportistas para ejecutar la acción");
      this.cerrarModalConfirmar();
      return;
    }

    const ruta = accion === "deshabilitar" ? "desactivar" : "activar";

    this.setState({ procesando: true });
    this.cerrarModalConfirmar();

    // Ejecutar en todos los transportistas asociados
    const promesas = idsTransportistas.map(idTransp =>
      Crud_Catalogos(
        "remolques_transportistas/" + ruta + "/" + remolque.idRemolque + "/" + idTransp,
        "", "put", "", { estatus: accion !== "deshabilitar" }, "", "", "", []
      ).catch(err => {
        console.error("Error al " + accion + " remolque " + remolque.idRemolque + " con transportista " + idTransp + ":", err);
        return null;
      })
    );

    Promise.all(promesas)
      .then(() => this.cargarRemolques())
      .finally(() => this.setState({ procesando: false }));
  };

  render() {
    const { remolques, remolquesDeshabilitados, cargandoRemolques, paginaActual, registrosPorPagina, remolqueEditar, accionModal, busqueda, mostrarDeshabilitados } = this.state;

    const remolquesFiltrados = this.filtrarRemolques();
    const indiceUltimo = paginaActual * registrosPorPagina;
    const indicePrimero = indiceUltimo - registrosPorPagina;
    const remolquesPaginados = remolquesFiltrados.slice(indicePrimero, indiceUltimo);
    const totalPaginas = Math.ceil(remolquesFiltrados.length / registrosPorPagina);

    return (
      <SiteWrapper>
        <Grid.Row>
          <Grid.Col width={12}>
            <Card>
              <Card.Header>
                <Card.Title>Catálogo de Remolques</Card.Title>
                <Card.Options>
                  <div onClick={this.exportarExcel} style={{ marginRight: '10px' }}>
                    <Button size="sm" color="purple">
                      <Icon name="download" /> Exportar
                    </Button>
                  </div>
                  <div onClick={() => this.setState({ showCargaMasiva: true })} style={{ marginRight: '10px' }}>
                    <Button size="sm" color="success">
                      <Icon name="upload" /> Carga Masiva
                    </Button>
                  </div>
                  
                  <div onClick={this.abrirModalNuevo}>
                    <Button size="sm" color="primary">
                      <Icon name="plus" /> Nuevo
                    </Button>
                  </div>
                  <ModalLay
                    tamanio="60%"
                    title={accionModal === "nuevo" ? "Nuevo Remolque" : "Editar Remolque"}
                    name={<span style={{display: 'none'}}></span>}
                    hiddenModal={this.state.hiddenModals}
                    Fclose={this.hiddenmodal}
                    formulario={RemolquesForm}
                    datosForm={{
                      accion: accionModal,
                      elementos: remolqueEditar,
                      cerrarModal: this.hiddenmodal,
                      idTransportista: this.state.idTransportista,
                      multiPlataforma: true
                    }}
                  />
                </Card.Options>
              </Card.Header>
              <Card.Body>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                  <div style={{ maxWidth: '400px', flex: 1 }}>
                    <Form.Input
                      icon="search"
                      placeholder="Buscar remolque..."
                      value={busqueda}
                      onChange={this.handleBusquedaChange}
                      disabled={cargandoRemolques}
                    />
                  </div>
                  <div className="switch-container-rem">
                    <label className="switch-toggle-rem">
                      <input
                        type="checkbox"
                        checked={mostrarDeshabilitados}
                        onChange={() => this.setState({ mostrarDeshabilitados: !mostrarDeshabilitados, paginaActual: 1 })}
                      />
                      <span className="switch-slider-rem"></span>
                    </label>
                    <span style={{ fontSize: '14px', color: '#6c757d' }}>
                      Mostrar deshabilitados {remolquesDeshabilitados.length > 0 && <span className="badge-deshabilitado-rem">{remolquesDeshabilitados.length}</span>}
                    </span>
                  </div>
                </div>

                {cargandoRemolques ? (
                  <TableSkeleton
                    title="Remolques"
                    headers={['Placa', 'Económico', 'Tipo de Remolque', 'GPS Fijo', 'Editar']}
                    isLoading={cargandoRemolques}
                  />
                ) : (
                  <>
                    <div style={{ 
                      textAlign: 'center', 
                      fontSize: '32px', 
                      fontWeight: 'bold', 
                      marginBottom: '30px',
                      color: '#467fcf'
                    }}>
                      Total de Remolques: {remolques.length}
                    </div>
                    
                    {remolquesFiltrados.length === 0 && !mostrarDeshabilitados && remolques.length === 0 ? (
                  <div style={{padding: '40px', textAlign: 'center'}}>
                    <Icon name="package" style={{fontSize: '48px', color: '#ccc'}} />
                    <h3>No hay remolques registrados</h3>
                    <p>Usa el botón "Nuevo" para agregar remolques</p>
                  </div>
                ) : remolquesFiltrados.length === 0 ? (
                  <div style={{padding: '40px', textAlign: 'center'}}>
                    <Icon name="search" style={{fontSize: '48px', color: '#ccc'}} />
                    <h3>No se encontraron remolques</h3>
                    <p>Intenta con otro término de búsqueda</p>
                  </div>
                ) : (
                  <div className="remolques-table-container">
                    <Table className="remolques-table" responsive>
                      <Table.Header>
                        <Table.Row>
                          <Table.ColHeader>Placa</Table.ColHeader>
                          <Table.ColHeader>Económico</Table.ColHeader>
                          <Table.ColHeader>Tipo de Remolque</Table.ColHeader>
                          <Table.ColHeader>GPS Fijo</Table.ColHeader>
                          {mostrarDeshabilitados && <Table.ColHeader>Estado</Table.ColHeader>}
                          <Table.ColHeader>Acciones</Table.ColHeader>
                        </Table.Row>
                      </Table.Header>
                      <Table.Body>
                        {remolquesPaginados.map((remolque) => (
                          <Table.Row key={remolque.idRemolque} className={!remolque._activo ? 'fila-deshabilitada' : ''}>
                            <Table.Col>
                              <div style={{ fontWeight: '600' }}>
                                {remolque.placa || '-'}
                              </div>
                            </Table.Col>
                            <Table.Col>{remolque.economico || '-'}</Table.Col>
                            <Table.Col>{remolque.remolquesTipos?.nombre || '-'}</Table.Col>
                            <Table.Col>{remolque.gpsFijoNombre || '-'}</Table.Col>
                            {mostrarDeshabilitados && (
                              <Table.Col>
                                <span style={{
                                  padding: '3px 10px',
                                  borderRadius: '12px',
                                  fontSize: '12px',
                                  fontWeight: '600',
                                  color: 'white',
                                  backgroundColor: remolque._activo ? '#5eba00' : '#dc3545'
                                }}>
                                  {remolque._activo ? 'Activo' : 'Deshabilitado'}
                                </span>
                              </Table.Col>
                            )}
                            <Table.Col>
                              {remolque._activo ? (
                                <>
                                  <Button 
                                    size="sm" 
                                    color="primary" 
                                    icon="edit"
                                    onClick={() => this.abrirModalEditar(remolque)}
                                  >
                                    Editar
                                  </Button>
                                  {' '}
                                  <Button 
                                    size="sm" 
                                    color="danger" 
                                    icon="x"
                                    disabled={this.state.procesando}
                                    onClick={() => this.abrirModalConfirmar(remolque, "deshabilitar")}
                                  >
                                    Deshabilitar
                                  </Button>
                                </>
                              ) : (
                                <Button 
                                  size="sm" 
                                  color="success" 
                                  icon="check"
                                  disabled={this.state.procesando}
                                  onClick={() => this.abrirModalConfirmar(remolque, "habilitar")}
                                >
                                  Habilitar
                                </Button>
                              )}
                            </Table.Col>
                          </Table.Row>
                        ))}
                      </Table.Body>
                    </Table>

                    <div style={{ 
                      display: 'flex', 
                      justifyContent: 'space-between', 
                      alignItems: 'center',
                      marginTop: '20px',
                      padding: '15px',
                      backgroundColor: '#f8f9fa',
                      borderRadius: '8px'
                    }}>
                      <div style={{ fontSize: '14px', color: '#6c757d' }}>
                        Mostrando {indicePrimero + 1} - {Math.min(indiceUltimo, remolquesFiltrados.length)} de {remolquesFiltrados.length} remolques
                      </div>
                      <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                        <Button
                          size="sm"
                          color="secondary"
                          disabled={paginaActual === 1}
                          onClick={() => this.cambiarPagina(paginaActual - 1)}
                        >
                          <Icon name="chevron-left" />
                        </Button>
                        
                        <span style={{ 
                          padding: '0 10px', 
                          fontSize: '14px', 
                          fontWeight: '600',
                          color: '#495057'
                        }}>
                          {paginaActual} / {totalPaginas}
                        </span>
                        
                        <Button
                          size="sm"
                          color="secondary"
                          disabled={paginaActual >= totalPaginas || totalPaginas === 0}
                          onClick={() => this.cambiarPagina(paginaActual + 1)}
                        >
                          <Icon name="chevron-right" />
                        </Button>
                      </div>
                    </div>
                  </div>
                )}
                </>
                )}
              </Card.Body>

              {/* Modal de confirmación */}
              {this.state.modalConfirmar.visible && (
                <div style={{
                  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                  backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
                  justifyContent: 'center', alignItems: 'center', zIndex: 9999
                }}>
                  <div style={{
                    backgroundColor: 'white', borderRadius: '12px', padding: '30px',
                    maxWidth: '400px', width: '90%', textAlign: 'center', boxShadow: '0 10px 30px rgba(0,0,0,0.3)'
                  }}>
                    <Icon 
                      name={this.state.modalConfirmar.accion === "deshabilitar" ? "alert-triangle" : "check-circle"} 
                      style={{ 
                        fontSize: '48px', 
                        color: this.state.modalConfirmar.accion === "deshabilitar" ? '#dc3545' : '#5eba00',
                        marginBottom: '15px'
                      }} 
                    />
                    <h4 style={{ marginBottom: '10px' }}>
                      {this.state.modalConfirmar.accion === "deshabilitar" ? "Deshabilitar Remolque" : "Habilitar Remolque"}
                    </h4>
                    <p style={{ color: '#6c757d', marginBottom: '25px' }}>
                      ¿Deseas {this.state.modalConfirmar.accion} este remolque?
                    </p>
                    <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                      <Button size="sm" color="secondary" onClick={this.cerrarModalConfirmar}>
                        Cancelar
                      </Button>
                      <Button 
                        size="sm" 
                        color={this.state.modalConfirmar.accion === "deshabilitar" ? "danger" : "success"} 
                        onClick={this.ejecutarAccionConfirmada}
                      >
                        {this.state.modalConfirmar.accion === "deshabilitar" ? "Deshabilitar" : "Habilitar"}
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            </Card>
          </Grid.Col>
        </Grid.Row>
        
        {/* Modal de Carga Masiva */}
        <ModalCargaMasiva
          isOpen={this.state.showCargaMasiva}
          onClose={() => this.setState({ showCargaMasiva: false })}
          title="Carga Masiva de Remolques"
          subtitle="Importa múltiples remolques desde un archivo Excel"
          config={remolquesConfig(this.state.idTransportista)}
          onDataLoaded={() => this.cargarRemolques()}
        />
      </SiteWrapper>
    );
  }
}

export default RemolquesPage;
